import {Injectable} from "@angular/core";
import { AdminUser, DefaultService, PsnbUserRolesPermissionConfig } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AdminUserService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllAdminUsers();
    }

    getAllAdminUsers() {
        return this.powerSupplyService.getAdminUsers().pipe(map(result => result));
    }

    createAdminUser(model: AdminUser) {
        return this.powerSupplyService.createAdminUser(model).pipe(map(result => result));
    }

    updateAdminUser(model: AdminUser) {
        return this.powerSupplyService.updateAdminUser(model).pipe(map(result => result));
    }

    deleteAdminUser(id: number) {
        return this.powerSupplyService.deleteAdminUser(id).pipe(map(result => result));
    }

    getAllRolesPermission(){
        return this.powerSupplyService.getAllPsUserRolesPermissionConfig().pipe(map(result => result));
    }

    updateRolesPermission(model: PsnbUserRolesPermissionConfig){
        return this.powerSupplyService.updateRolesPermission(model).pipe(map(result => result));
    }

    getUserRolePermissionConfigs(){
        return this.powerSupplyService.getUserRolePermissionConfigs().pipe(map(result => result));
    }
}
